<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">活动详情</span>
        </template>
    </NavBar>
    <div class="main" v-if="activity">
        <img :src="activity.top_background" class="top">
        <div class="middle" :style="{backgroundImage: `url(${activity.middle_background})`}">
            <div class="notice">
                <div class="info">{{ notices.length ? `${notices[noticeIndex].user}刚刚抽中了${notices[noticeIndex].name}` : '' }}</div>
                <div class="number">剩余抽奖机会：<span>{{ activity.number }}</span>次</div>
            </div>
            <div class="grand">
                <van-swipe :show-indicators="false" v-if="activity.grands.length">
                    <van-swipe-item v-for="(group, index) in activity.grands" :key="index">
                        <img :src="url" v-for="url in group" :key="url">
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="roll">
                <div class="track" :style="{left: '-' + trackLeft + 'px'}">
                    <template v-for="index in trackGroup" :key="index">
                        <img :src="prize.roll_image" v-for="prize in activity.prizes" :key="prize.id">
                    </template>
                </div>
            </div>
            <img src="@/assets/images/activity-luckdraw.png" class="luckdraw" @click="luckdraw">
            <div class="tab">
                <div class="item" @click="tabType = 'rule'" :style="{background: `linear-gradient(0deg, ${activity.panel_color}, ${activity.color})`}">活动规则</div>
                <div class="item" @click="tabType = 'chance'" :style="{background: `linear-gradient(0deg, ${activity.panel_color}, ${activity.color})`}">中奖概率</div>
                <div class="item" @click="tabType = 'record'" :style="{background: `linear-gradient(0deg, ${activity.panel_color}, ${activity.color})`}">中奖纪录</div>
            </div>
        </div>
        <div class="tab-box" :style="{backgroundImage: `url(${activity.bottom_background})`}">
            <div class="tab-title" :style="{backgroundImage: `url(${activity.panel_background})`}">— {{ tabType == 'rule' ? '活动规则' : (tabType == 'chance' ? '中奖概率' : '中奖纪录') }} —</div>
            <div class="tab-content" :style="`background-color: ${hexToRgb(activity.panel_color, 0.5)}`">
                <pre v-if="tabType == 'rule'">{{ activity.rule }}</pre>
                <pre v-if="tabType == 'chance'">{{ activity.chance_description }}</pre>
                <!-- <template v-else-if="tabType == 'chance'">
                    <div class="chance" v-for="prize in activity.prizes" :key="prize.id">
                        <span>{{ prize.name }}</span>
                        <div class="spot">............................................................................................</div>
                        <span>{{ prize.chance }}</span>
                    </div>
                </template> -->
                <template v-if="tabType == 'record'">
                    <div class="record" v-for="(record, index) in activity.records" :key="index">
                        <span>{{ record.name }}</span>
                        <span>{{ dateFormat('YYYY.mm.dd', record.time) }}</span>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <van-overlay :show="trackConfig.showPrize" class="success-overlay">
        <div class="prize">
            <img src="@/assets/images/close.png" class="close" @click="trackConfig.showPrize = false">
            <img :src="trackConfig.prize.image" class="image">
            <p class="name">恭喜您抽中{{ trackConfig.prize.name }}</p>
            <img src="@/assets/images/activity-receive.png" class="receive" @click="jump">
        </div>
    </van-overlay>
    
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>